<template>
  <div class="home" ref="root">
    <mountain-scene :bound="0.65" ref="scene" />
    <div class="messaging">
      <h2 class="title">Let Your Taste</h2>
      <wander-text />
      <p class="intro">
        In the heart of the exotic fruit section awaits
        an exciting adventure that will shake up your
        shopping list. Get ready to discover what makes
        Zespri SunGold the better, sweeter kiwifruit.
      </p>
    </div>
    <button class="watch-videos" @click="showVideo()">
      <play-icon class="play" /><span class="button-text">Watch the commercials</span>
    </button>
  </div>
</template>

<script>
import store from '../store'
import MountainScene from '../components/mountain-scene/MountainScene.vue'
import WanderText from '../components/mountain-scene/WanderText.vue'
import imageData from '../components/mountain-scene/image-data'
import PlayIcon from '../assets/icons/play.svg?inline'

export default {
  name: 'home',
  components: {
    'play-icon': PlayIcon,
    'wander-text': WanderText,
    'mountain-scene': MountainScene
  },
  data() {
    return {
      listening: false,
      images: imageData,
    }
  },
  props: {
    active: {
      default: true,
      type: Boolean
    },
    width: {
      default: 0,
      type: Number
    },
    height: {
      default: 0,
      type: Number
    }
  },
  watch: {
    active(active) {
      if (active) {
        // this.onResize()
        this.play()
      } else {
        this.pause()
      }
    }
  },
  methods: {
    percent(p) {
      return `${p * 100}%`
    },
    determineImageSize() {
      const config = this.images.mountain
      const w = window.innerWidth
      const h = window.innerHeight
      const list = ['xs', 's', 'm', 'l'].map((s) => {
        return { size: s, width: config[s].width, height: config[s].height }
      })
      for (let i = 0; i < list.length; i++) {
        const c = list[i]
        if (c.width >= w && c.height >= h) {
          return c.size
        }
      }
      return 'l'
    },
    play() {
      this.$refs.scene.play()
    },
    pause() {
      this.$refs.scene.pause()
    },
    showVideo() {
      store.commit('openModal', 'commercials')
    }
  }
}
</script>

<style lang="scss">
/** Home (unscoped) **/
.home {
  canvas {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
</style>

<style scoped lang="scss">
/** Home **/
@import '../theme';

.home {
  position: relative;
  width: 100%;
  height: 100%;
}

.messaging {
  position: absolute;
  top: 35%;
  left: 10%;
  z-index: 10;
  width: 80%;
  max-width: 330px;
}

// $text-shadow: 2px -2px 153px rgba(39, 30, 13, 0.5);
$text-shadow: 2px -2px 33px rgba(39, 30, 13, 1);
// Outlined
// $text-shadow:
//   -1px -1px 0 rgba(0, 0, 0, 0.3),
//    1px -1px 0 rgba(0, 0, 0, 0.3),
//   -1px  1px 0 rgba(0, 0, 0, 0.3),
//    1px  1px 0 rgba(0, 0, 0, 0.3);

.title {
  margin: 0;
  // transform: translate(-20px, -100%);

  @include zespri-small-callout;
  color: $white;
  text-transform: none;
  text-align: left;
  text-shadow: $text-shadow;
}

.intro {
  margin: 0;
  transform: translateY(-60%);

  @include zespri-body-bold-font;
  color: $white;

  text-shadow: $text-shadow;

  @include media-breakpoint-up(md) {
    transform: translateY(0);
  }
}

.watch-videos {
  @include cta-button-pill;
  position: absolute;
  z-index: zespri-layer(normal);
  top: 115px;
  right: 8%;

  transition: transform $t-m $e-out-hard;

  &:hover {
    transform: scale(1.08);
  }

  @include media-breakpoint-up(lg) {
    top: 7%;
    right: 10%;
  }
}

.play {
  width: 17px;
  height: 17px;
  margin-right: 10px;
  fill: white;
  stroke: white;
  stroke-width: 2px;
}

.button-text {
  margin-top: 3px;
}
</style>
